__turbopack_context__.v({
  "actions": "GuidedOnboardingPanel-module__tqhLQG__actions",
  "collapseButton": "GuidedOnboardingPanel-module__tqhLQG__collapseButton",
  "count": "GuidedOnboardingPanel-module__tqhLQG__count",
  "description": "GuidedOnboardingPanel-module__tqhLQG__description",
  "eyebrow": "GuidedOnboardingPanel-module__tqhLQG__eyebrow",
  "footer": "GuidedOnboardingPanel-module__tqhLQG__footer",
  "header": "GuidedOnboardingPanel-module__tqhLQG__header",
  "headerActions": "GuidedOnboardingPanel-module__tqhLQG__headerActions",
  "panel": "GuidedOnboardingPanel-module__tqhLQG__panel",
  "progressFill": "GuidedOnboardingPanel-module__tqhLQG__progressFill",
  "progressTrack": "GuidedOnboardingPanel-module__tqhLQG__progressTrack",
  "title": "GuidedOnboardingPanel-module__tqhLQG__title",
});
